// Multi-territory Navigation/Sidebar API service
// Pattern matches src/api/compute.js

import { MT_NAVIGATION_API } from '@/multi-territory/mt-services/mt-api-endpoints'
import {
  MTApiResponse,
  mtBuildRequestHeader,
  mtHandleErrorResponse,
  mtHandleRequestFailure,
  mtHandleSuccessResponse,
  mtUrlBuilder,
} from '@/multi-territory/mt-services/mt-api-utils'
import { MTSidebarModuleResponse } from '@/multi-territory/mt-types/mt-shared'

/**
 * Fetches navigation/sidebar modules for a given country.
 * GET /wht-admin/api/admin/api/v1/navigation/{countryCode}
 */
export const fetchNavigationModules = async (
  countryCode: string
): Promise<MTApiResponse<MTSidebarModuleResponse>> => {
  const url = mtUrlBuilder(MT_NAVIGATION_API, { countryCode })
  const requestHeader = mtBuildRequestHeader('GET')

  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await mtHandleRequestFailure(response)
    return await mtHandleSuccessResponse<MTSidebarModuleResponse>(response)
  } catch (error) {
    return mtHandleErrorResponse(error)
  }
}
